/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateParameterNameRequestDto } from './CreateParameterNameRequestDto';
import {
    CreateParameterNameRequestDtoFromJSON,
    CreateParameterNameRequestDtoFromJSONTyped,
    CreateParameterNameRequestDtoToJSON,
    CreateParameterNameRequestDtoToJSONTyped,
} from './CreateParameterNameRequestDto';

/**
 * 
 * @export
 * @interface BatchImportParameterNamesRequestDto
 */
export interface BatchImportParameterNamesRequestDto {
    /**
     * Array of parameter names to import
     * @type {Array<CreateParameterNameRequestDto>}
     * @memberof BatchImportParameterNamesRequestDto
     */
    items: Array<CreateParameterNameRequestDto>;
}

/**
 * Check if a given object implements the BatchImportParameterNamesRequestDto interface.
 */
export function instanceOfBatchImportParameterNamesRequestDto(value: object): value is BatchImportParameterNamesRequestDto {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function BatchImportParameterNamesRequestDtoFromJSON(json: any): BatchImportParameterNamesRequestDto {
    return BatchImportParameterNamesRequestDtoFromJSONTyped(json, false);
}

export function BatchImportParameterNamesRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BatchImportParameterNamesRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(CreateParameterNameRequestDtoFromJSON)),
    };
}

export function BatchImportParameterNamesRequestDtoToJSON(json: any): BatchImportParameterNamesRequestDto {
    return BatchImportParameterNamesRequestDtoToJSONTyped(json, false);
}

export function BatchImportParameterNamesRequestDtoToJSONTyped(value?: BatchImportParameterNamesRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(CreateParameterNameRequestDtoToJSON)),
    };
}

